<!-- Schedule session form -->
<form
    #createSessionForm="ngForm"
    (ngSubmit)="onSubmit(createSessionForm)"
    novalidate
    class="w-full flex flex-col justify-start items-center mt-2 gap-2">
    <p-select
        size="large"
        class="w-full"
        [options]="timeSlotValues"
        [(ngModel)]="formModel.selectedTimeValue"
        (onChange)="selectedTimeSlot($event)"
        name="selectedTimeOption"
        optionLabel="name"
        optionValue="value">
        <ng-template #selectedItem let-selectedOption>
            <div class="flex items-center gap-2">
                <i class="pi pi-clock !text-[14px]"></i>
                <div>{{ selectedOption.name }}</div>
            </div>
        </ng-template>
    </p-select>

    <p-datepicker
        [dt]="datePickerToken"
        appendTo="body"
        class=""
        inputStyleClass="!py-[7px] !text-[14px] !text-color"
        name="date"
        [minDate]="minDate"
        dateFormat="'{{ dateDisplayString }}'"
        [(ngModel)]="formModel.date"
        [readonlyInput]="true"
        [iconDisplay]="'input'"
        [showIcon]="true"
        inputId="templatedisplay"
        (onSelect)="onDateSelected($event)">
        <ng-template #inputicon let-clickCallBack="clickCallBack">
            <i
                class="pi pi-chevron-down !text-[14px] text-color"
                (click)="clickCallBack($event)"></i>
        </ng-template>
    </p-datepicker>

    <p-button
        size="small"
        severity="secondary"
        [text]="true"
        [label]="!expandMoreOptions ? 'Show more options' : 'Hide more options'"
        styleClass="!text-12"
        (click)="expandMoreOptions = !expandMoreOptions" />

    @if (expandMoreOptions) {
        <div class="flex flex-col w-full gap-2">
            <p-select
                size="large"
                class="w-full"
                [options]="favoritesPreferences"
                [(ngModel)]="formModel.favoritesPreference"
                (onChange)="selectedFavoritesPreference($event)"
                name="favoritesPreference"
                optionLabel="name"
                optionValue="value">
                <ng-template #selectedItem let-selectedOption>
                    <div class="flex items-center gap-2">
                        <i [ngClass]="selectedOption.icon" class="!text-[14px]"></i>
                        <div>{{ selectedOption.name }}</div>
                    </div>
                </ng-template></p-select
            >

            <p-select
                size="large"
                class="w-full"
                [options]="recurType"
                [(ngModel)]="formModel.recurrenceType"
                (onChange)="selectedRecurrenceType($event)"
                name="recurType"
                optionLabel="name"
                optionValue="value">
                <ng-template #selectedItem let-selectedOption>
                    <div class="flex items-center gap-2">
                        <i [ngClass]="selectedOption.icon" class="!text-[14px]"></i>
                        <div>{{ selectedOption.name }}</div>
                    </div>
                </ng-template></p-select
            >

            <p-select
                size="large"
                class="w-full"
                [options]="recurTimes"
                [(ngModel)]="formModel.recurrenceFrequency"
                (onChange)="selectedRecurFrequency($event)"
                name="recurTime"
                optionLabel="name"
                optionValue="value">
                <ng-template #selectedItem let-selectedOption>
                    <div class="flex items-center gap-2">
                        <i class="pi pi-list !text-[14px]"></i>
                        <div>{{ selectedOption.name }}</div>
                    </div>
                </ng-template></p-select
            >

            <p-iconfield>
                <p-inputicon styleClass="pi pi-check-square !text-[14px]" />
                <input
                    class="w-full"
                    size="small"
                    [dt]="inputTextToken"
                    type="text"
                    name="title"
                    pInputText
                    placeholder="Your session title"
                    [(ngModel)]="formModel.title" />
            </p-iconfield>
        </div>
    }
    <p-button
        type="submit"
        severity="primary"
        [disabled]="!isTimevalid"
        size="large"
        label="Schedule for {{ formModel.selectedTimeValue }}"
        class="w-full mt-4"
        classes="w-full"
        styleClass="!h-12 w-full" />
</form>
